interface SetCompletionBarProps {
  owned: number;
  total: number;
  completionPct: number;
  game?: string;
  setName: string;
  showLabel?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export default function SetCompletionBar({
  owned,
  total,
  completionPct,
  game,
  setName,
  showLabel = true,
  size = 'md',
}: SetCompletionBarProps) {
  const barHeight = size === 'sm' ? 'h-1.5' : size === 'lg' ? 'h-3' : 'h-2';
  const textSize  = size === 'sm' ? 'text-xs' : size === 'lg' ? 'text-sm' : 'text-xs';

  // Color shifts from red → yellow → green based on completion
  const barColor =
    completionPct >= 100 ? 'bg-emerald-500' :
    completionPct >= 75  ? 'bg-green-500'   :
    completionPct >= 50  ? 'bg-yellow-500'  :
    completionPct >= 25  ? 'bg-orange-500'  :
                           'bg-red-400';

  return (
    <div className="w-full">
      {showLabel && (
        <div className="flex items-baseline justify-between mb-1 gap-2">
          <div className="min-w-0">
            {game && (
              <span className={`${textSize} text-gray-500 dark:text-zinc-500 mr-1`}>{game} ·</span>
            )}
            <span className={`${textSize} font-medium text-gray-700 dark:text-zinc-300 truncate`}>{setName}</span>
          </div>
          <span className={`${textSize} font-bold shrink-0 ${
            completionPct >= 100 ? 'text-emerald-600' : 'text-gray-600 dark:text-zinc-400'
          }`}>
            {owned}/{total}
          </span>
        </div>
      )}

      <div className={`w-full bg-gray-100 dark:bg-zinc-800 rounded-full overflow-hidden ${barHeight}`}>
        <div
          className={`${barHeight} ${barColor} rounded-full transition-all duration-500`}
          style={{ width: `${Math.min(completionPct, 100)}%` }}
        />
      </div>

      {showLabel && (
        <p className={`${textSize} text-gray-500 dark:text-zinc-500 mt-0.5 text-right`}>
          {completionPct.toFixed(1)}%
          {completionPct >= 100 && ' 🏆'}
        </p>
      )}
    </div>
  );
}
